import React from 'react';
import { LinkIcon } from '@heroicons/react/24/solid';
import { ReactComponent as IconSnippet } from 'assets/images/icon-snippet.svg';

const OptionSectionMobile = ({ status, changeStatus }) => {
  return (
    <div className='md:hidden w-full grid grid-cols-2 gap-x-2 mb-3'>
      <button
        className={`share-button w-full transition-[1000ms]  ${status === 'generate' && 'isActive'}`}
        onClick={() => changeStatus('generate')}
      >
        <LinkIcon className={`h-7 w-7 ${status === 'generate' ? 'text-neutral-black' : 'text-neutral-silver-200'}`} />
      </button>
      <button
        className={`share-button w-full transition-[2000ms] ${status === 'snippet' && 'isActive'}`}
        onClick={() => changeStatus('snippet')}
      >
        <IconSnippet className='h-7 w-7' fill={`${status === 'snippet' ? 'black' : '#C4C9CF'}`} />
      </button>
    </div>
  );
};

export default OptionSectionMobile;
